export const ClaimTypeCash = "Cash";
export const ClaimTypeCredit = "Credit";
export const ClaimTypeBank = "Bank";

export const ClaimTypesIDs = {
  Bank: 1,
  Cash: 2,
  Credit: 3,
};

export const AgencyClaimTypes = [
  {
    id: 1,
    icon: <></>,
    text: ClaimTypeBank,
  },
  {
    id: 2,
    icon: <></>,
    text: ClaimTypeCash,
  },
  {
    id: 3,
    icon: <></>,
    text: ClaimTypeCredit,
  },
];

export const SystemAgencyClaimTypes = [
  {
    id: 1,
    icon: <></>,
    text: ClaimTypeBank,
  },
  {
    id: 2,
    icon: <></>,
    text: ClaimTypeCash,
  },
];
